const types = {
    SET_WITHDRAWALS: '[WITHDRAWALS] SET WITHDRAWALS',
}

export {
    types
}